module.exports = __webpack_public_path__ + "img/right1.f12c26d4.png";